export default __webpack_public_path__ + "cf048f72934fd71e99c8357455ad961d.png";